/**
 * Created by asiulik on 23.05.2017.
 */

define(['jquery', 'jssocials'], function ($) {

    var shareContainer = '#page__share';
    var defaultShareConfig = 'facebook,twitter,linkedin,email,whatsapp';

    var sharesConfig = {
        facebook: {
            share: "facebook",
            label: "facebook",
            logo: "facebook",
            css: "socialbox__item social__icons__item facebook"
        },
        twitter: {
            share: "twitter",
            label: "twitter",
            logo: "icon",
            css: "socialbox__item social__icons__item twitter"
        },
        email: {
            share: "email",
            label: "email",
            logo: "icon",
            css: "socialbox__item social__icons__item email"
        },
        linkedin: {
            share: "linkedin",
            label: "linkedin",
            logo: "icon",
            css: "socialbox__item social__icons__item linkedin"
        },
        whatsapp: {
            share: "whatsapp",
            label: "whatsapp",
            logo: "icon",
            css: "socialbox__item social__icons__item whatsapp"
        },
    };

    function Share() {
    }

    Share.prototype.init = function () {


        var _this = this;
        this.$shareContainer = $(shareContainer);
        if(!this.$shareContainer.length) return;

        this.$shareContainer.jsSocials({
            showLabel: false,
            shares: _this.buildShareConfig()
        });

    };

    Share.prototype.buildShareConfig = function () {

        var configArr = [];

        var shareConfig = this.$shareContainer.data('shareConfig') || defaultShareConfig;
        var shareConfigArray = shareConfig.split(',');

        shareConfigArray.map(function(shareName) {
            configArr.push(sharesConfig[shareName] || shareName);
        });

        return configArr;

    };

    return Share;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/share.js